import { AxiosRequest } from "_services/api";
import {
  IData,
  IHttpError,
  IHttpResponse,
} from "_services/api/interface/HttpResponse";
import { usePaginationSortSearch } from "containers/Table/hooks/usePaginationSortSearch";
import { useCallback, useState } from "react";
import { HttpResponse } from "_services/api/HttpResponse";
import { HttpError } from "_services/api/HttpError";
import { IListarPagamentoFornecedorAguardando } from "../interface/IListarPagamentoFornecedorAguardando";
import { IFiltrosAguardandoPagamento } from "../interface/IFiltrosAguardandoPagamento";
import { IDetalheLotePagamento } from "../interface/IDetalheLotePagamento";
import { IFiltrosAprovadoPagamento } from "../interface/IFiltrosAprovadoPagamento";
import { IListarPagamentoFornecedorAprovado } from "../interface/IListarPagamentoFornecedorAprovado";
import { IConfirmarPagamento } from "../interface/IConfirmarPagamento";
import { IFiltrosPagamentosReprovados } from "../interface/IFiltrosPagamentosReprovados";
import { IListarPagamentoReprovadoFornecedor } from "../interface/IListarPagamentoReprovadoFornecedor";
import { Data } from "_utils/Data";
import { toastAtencao, toastErro } from "components/Toast";
import { IFiltroProcessoCriarLote } from "../interface/IFiltroProcessoCriarLote";
import { IProcessoVincularLote } from "../interface/IProcessoVincularLote";
import { ICriarLote } from "../interface/ICriarLote";
import {
  IListaLancamentos,
  IProcessoCriarLote,
} from "../interface/IProcessosCriarLote";
import { IOptions } from "components/DropdownSelect";
import { IEditarProcesso } from "../interface/IEditarProcesso";
import { IAtualizarLote } from "../interface/IAtualizarLote";

export function useProcessoFinanceiroAprovar() {
  const msAw = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW);
  const api = AxiosRequest.makeApi();
  const { totalRows, setTotalRows } = usePaginationSortSearch();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState<IListarPagamentoFornecedorAguardando[]>(
    [],
  );
  const [dadosAprovados, setDadosAprovados] = useState<
    IListarPagamentoFornecedorAprovado[]
  >([]);
  const [dadosReprovados, setDadosReprovados] = useState<
    IListarPagamentoReprovadoFornecedor[]
  >([]);
  const [error, setError] = useState<IHttpResponse<IData | any>>();
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(50);
  const [filtro, setFiltro] = useState<IFiltrosAguardandoPagamento>({});
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [clearRows, setClearRows] = useState<boolean>(false);
  const [selectedRowsCorrigir, setSelectedRowsCorrigir] = useState<any[]>([]);
  const [idLoteEscolhido, setIdLoteEscolhido] = useState<null | number>(null);
  const [idLoteCorrigir, setIdLoteCorrigir] = useState<null | number>(null);
  const [numeroNfReciboEscolhido, setNumeroNfReciboEscolhido] =
    useState<string>("");
  const [dadosDetalhes, setDadosDetalhes] = useState<IDetalheLotePagamento[]>(
    [],
  );
  const [filtroListaAprovados, setFiltroListaAprovados] =
    useState<IFiltrosAguardandoPagamento>({});
  const [filtroListaReprovados, setFiltroListaReprovados] =
    useState<IFiltrosPagamentosReprovados>({});
  const mimeMap: Record<string, string> = {
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      "docx",
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "text/csv": "csv",
    "text/plain": "txt",
    "text/html": "html",
    "application/pdf": "pdf",
    "image/jpeg": "jpg",
    "image/png": "png",
    "application/xml": "xml",
    "image/tiff": "tiff",
    "image/bmp": "bmp",
    "application/vnd.oasis.opendocument.text": "odt",
    "application/vnd.oasis.opendocument.spreadsheet": "ods",
    "application/vnd.oasis.opendocument.presentation": "odp",
  };
  const [processosVincularLote, setProcessosVincularLote] = useState<
    IProcessoVincularLote[]
  >([]);

  const getParamsFiltro = (
    obj: any,
    dadosFiltros: IFiltrosAguardandoPagamento,
  ) => {
    if (dadosFiltros.idEmpresa) {
      obj.idEmpresa = dadosFiltros.idEmpresa;
    }

    if (dadosFiltros.idFornecedor) {
      obj.idFornecedor = dadosFiltros.idFornecedor;
    }

    if (dadosFiltros.idsProcessos) {
      obj.processos = JSON.stringify(dadosFiltros.idsProcessos);
    }

    if (dadosFiltros.idsLotes) {
      obj.lotes = JSON.stringify(dadosFiltros.idsLotes);
    }

    if (dadosFiltros.numeroNfRecibo) {
      obj.numeroNfRecibo = dadosFiltros.numeroNfRecibo;
    }

    if (
      dadosFiltros.periodo &&
      dadosFiltros.periodo[0] &&
      dadosFiltros.periodo[1]
    ) {
      obj.dataInicio = new Data(dadosFiltros.periodo[0]).getDataEua();
      obj.dataFim = new Data(dadosFiltros.periodo[1]).getDataEua();
    }

    if (dadosFiltros.placa) {
      obj.placa = dadosFiltros.placa;
    }
    const params = Object.keys(obj)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`,
      )
      .join("&");

    return params;
  };

  const getParamsFiltroAprovados = (
    obj: any,
    dadosFiltros: IFiltrosAprovadoPagamento,
  ) => {
    if (dadosFiltros.idEmpresa) {
      obj.idEmpresa = dadosFiltros.idEmpresa;
    }

    if (dadosFiltros.idFornecedor) {
      obj.idFornecedor = dadosFiltros.idFornecedor;
    }

    if (dadosFiltros.idsProcessos) {
      obj.processos = JSON.stringify(dadosFiltros.idsProcessos);
    }

    if (dadosFiltros.idsLotes) {
      obj.lotes = JSON.stringify(dadosFiltros.idsLotes);
    }

    if (dadosFiltros.numeroNfRecibo) {
      obj.numeroNfRecibo = dadosFiltros.numeroNfRecibo;
    }

    if (
      dadosFiltros.periodoPagamento &&
      dadosFiltros.periodoPagamento[0] &&
      dadosFiltros.periodoPagamento[1]
    ) {
      obj.dataInicioPagamento = new Data(
        dadosFiltros.periodoPagamento[0],
      ).getDataEua();
      obj.dataFimPagamento = new Data(
        dadosFiltros.periodoPagamento[1],
      ).getDataEua();
    }

    if (
      dadosFiltros.periodoValidacao &&
      dadosFiltros.periodoValidacao[0] &&
      dadosFiltros.periodoValidacao[1]
    ) {
      obj.dataInicioValidacao = new Data(
        dadosFiltros.periodoValidacao[0],
      ).getDataEua();
      obj.dataFimValidacao = new Data(
        dadosFiltros.periodoValidacao[1],
      ).getDataEua();
    }

    if (dadosFiltros.placa) {
      obj.placa = dadosFiltros.placa;
    }

    if (dadosFiltros.statusPagamento) {
      obj.statusPagamento = dadosFiltros.statusPagamento;
    }

    const params = Object.keys(obj)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`,
      )
      .join("&");

    return params;
  };

  const getParamsFiltroReprovados = (
    obj: any,
    dadosFiltros: IFiltrosPagamentosReprovados,
  ) => {
    if (dadosFiltros.idEmpresa) {
      obj.idEmpresa = dadosFiltros.idEmpresa;
    }

    if (dadosFiltros.idFornecedor) {
      obj.idFornecedor = dadosFiltros.idFornecedor;
    }

    if (dadosFiltros.idsProcessos) {
      obj.processos = JSON.stringify(dadosFiltros.idsProcessos);
    }

    if (dadosFiltros.idsLotes) {
      obj.lotes = JSON.stringify(dadosFiltros.idsLotes);
    }

    if (dadosFiltros.numeroNfRecibo) {
      obj.numeroNfRecibo = dadosFiltros.numeroNfRecibo;
    }

    if (
      dadosFiltros.periodoValidacao &&
      dadosFiltros.periodoValidacao[0] &&
      dadosFiltros.periodoValidacao[1]
    ) {
      obj.dataInicioValidacao = new Data(
        dadosFiltros.periodoValidacao[0],
      ).getDataEua();
      obj.dataFimValidacao = new Data(
        dadosFiltros.periodoValidacao[1],
      ).getDataEua();
    }

    if (dadosFiltros.placa) {
      obj.placa = dadosFiltros.placa;
    }
    const params = Object.keys(obj)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`,
      )
      .join("&");

    return params;
  };

  const listar = useCallback(
    async (dadosFiltros?: IFiltrosAguardandoPagamento, status = "PENDENTE") => {
      setLoading(true);
      setClearRows(true);
      const obj: any = { pagina: page, limite: limit, status };

      if (dadosFiltros) {
        setFiltro(dadosFiltros);
      }

      const params = getParamsFiltro(obj, dadosFiltros ?? filtro);

      try {
        const { status, data } = await msAw.get(
          `/fornecedores/pagamento/lote?${params}`,
        );

        setDados(data.itens);
        setTotalRows(data.meta.total);
        const response = new HttpResponse(false, status, data);
        setError(response);
        return response;
      } catch (error: IHttpError<IData, any> | any) {
        const response = new HttpError<IData>(true, error);
        setError(response);
        setDados([]);
        setTotalRows(0);
        return response;
      } finally {
        setLoading(false);
        setClearRows(false);
      }
    },
    [page, limit, filtro],
  );

  const aprovarLotes = useCallback(async () => {
    setLoading(true);
    try {
      const { status, data } = await api.post(
        `/processos/financeiro/aprovar/`,
        {
          idsLotes: JSON.stringify(selectedRows.map((item) => item.id)),
          status: "APROVADO",
        },
      );
      const response = new HttpResponse(false, status, data);
      setSelectedRows([]);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    } finally {
      setLoading(false);
    }
  }, [selectedRows]);

  const reprovarLotes = useCallback(async () => {
    setLoading(true);
    try {
      const { status, data } = await api.post(
        `/processos/financeiro/aprovar/`,
        {
          idsLotes: JSON.stringify(selectedRows.map((item) => item.id)),
          status: "REPROVADO",
        },
      );
      const response = new HttpResponse(false, status, data);
      setSelectedRows([]);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    } finally {
      setLoading(false);
    }
  }, [selectedRows]);

  const buscarEstatisticasLotePagamento = async (idLote: number) => {
    try {
      const { status, data } = await msAw.get(
        `/fornecedores/pagamento/lote/${idLote}/estatisticas`,
      );
      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    }
  };

  const buscarEstatisticasPagamento = async (
    idProcessoFinanceiroAprovar: number,
  ) => {
    try {
      const { status, data } = await msAw.get(
        `/fornecedores/pagamento/${idProcessoFinanceiroAprovar}/estatisticas`,
      );
      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    }
  };

  const buscarDetalhesLotePagamento = useCallback(async () => {
    try {
      const { status, data } = await msAw.get(
        `/fornecedores/pagamento/lote/${
          idLoteEscolhido ?? idLoteCorrigir
        }/detalhes`,
      );
      const response = new HttpResponse(false, status, data);
      setError(response);
      setDadosDetalhes(data.detalhes);
      setNumeroNfReciboEscolhido(data.numero_nf_recibo);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      setDadosDetalhes([]);
      setNumeroNfReciboEscolhido("");
      return response;
    }
  }, [idLoteEscolhido, idLoteCorrigir]);

  const onClickProcesso = async (id: number | string) => {
    setLoading(true);
    try {
      const { status, data } = await api.get(`/processos/param/${id}`);
      window.open(
        `${process.env.REACT_APP_DESPACHANTE_BASE_URL}/pages/processo/Processo.php?param=${data}`,
        "_blank",
      );
      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    } finally {
      setLoading(false);
    }
  };

  const relatorioDetalhado = async (
    statusAprovacaoLote: "APROVADO" | "PENDENTE" | "REPROVADO",
  ) => {
    const obj: any = { status: statusAprovacaoLote };

    if (selectedRows.length) {
      obj.idsLotes = JSON.stringify(selectedRows.map((row) => row.id));
    } else {
      obj.ultimosDias = 90;
    }

    const strategyGetFiltro = {
      APROVADO: getParamsFiltroAprovados(obj, filtroListaAprovados),
      PENDENTE: getParamsFiltro(obj, filtro),
      REPROVADO: getParamsFiltroReprovados(obj, filtroListaReprovados),
    };
    const params = strategyGetFiltro[statusAprovacaoLote];

    try {
      const { status, data } = await msAw.get(
        `/fornecedores/pagamento/lote/relatorio/detalhado?${params}`,
      );
      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    }
  };

  const relatorioResumido = useCallback(
    async (statusAprovacaoLote: "APROVADO" | "PENDENTE" | "REPROVADO") => {
      setLoading(true);
      const obj: any = {
        limite: 0,
        ultimosDias: 90,
        status: statusAprovacaoLote,
      };

      const strategyGetFiltro = {
        APROVADO: getParamsFiltroAprovados(obj, filtroListaAprovados),
        PENDENTE: getParamsFiltro(obj, filtro),
        REPROVADO: getParamsFiltroReprovados(obj, filtroListaReprovados),
      };
      const params = strategyGetFiltro[statusAprovacaoLote];

      try {
        const { status, data } = await msAw.get(
          `/fornecedores/pagamento/lote?${params}`,
        );

        const response = new HttpResponse(false, status, data);
        setError(response);
        return response;
      } catch (error: IHttpError<IData, any> | any) {
        const response = new HttpError<IData>(true, error);
        setError(response);
        return response;
      } finally {
        setLoading(false);
      }
    },
    [page, limit],
  );

  const validarProcessos = async (processos: number[]) => {
    setLoading(true);
    try {
      const { status, data } = await msAw.get(
        `/processo/validar/?processos=${JSON.stringify(processos)}`,
      );

      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    } finally {
      setLoading(false);
    }
  };

  const validarLotes = async (lotes: number[]) => {
    setLoading(true);
    try {
      const { status, data } = await msAw.get(
        `/fornecedores/pagamento/lote/validar/?lotes=${JSON.stringify(lotes)}`,
      );

      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    } finally {
      setLoading(false);
    }
  };

  const listarAprovados = useCallback(
    async (dadosFiltros?: IFiltrosAprovadoPagamento, status = "APROVADO") => {
      setLoading(true);
      setClearRows(true);
      const obj: any = { pagina: page, limite: limit, status };

      if (dadosFiltros) {
        setFiltroListaAprovados(dadosFiltros);
      }

      const params = getParamsFiltroAprovados(
        obj,
        dadosFiltros ?? filtroListaAprovados,
      );

      try {
        const { status, data } = await msAw.get(
          `/fornecedores/pagamento/lote/?${params}`,
        );

        setDadosAprovados(data.itens);
        setTotalRows(data.meta.total);
        const response = new HttpResponse(false, status, data);
        setError(response);
        return response;
      } catch (error: IHttpError<IData, any> | any) {
        const response = new HttpError<IData>(true, error);
        setError(response);
        setDadosAprovados([]);
        setTotalRows(0);
        return response;
      } finally {
        setLoading(false);
        setClearRows(false);
      }
    },
    [page, limit],
  );

  const confirmarPagamento = async (dados: IConfirmarPagamento) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("arquivo", dados.arquivo);
      formData.append("dataPagamento", dados.dataPagamento);
      formData.append(
        "idsLotes",
        JSON.stringify(selectedRows.map((row) => row.id)),
      );

      const { status, data } = await msAw.post(
        "/fornecedores/pagamento/lote/comprovante",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const response = new HttpResponse(false, status, data);
      setError(response);
      listarAprovados();
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    } finally {
      setLoading(false);
    }
  };

  const buscarComprovantes = async (idsLotes: number[]) => {
    try {
      const { status, data } = await msAw.get(
        `/fornecedores/pagamento/lote/comprovantes/?idsLotes=${JSON.stringify(
          idsLotes,
        )}`,
        {
          responseType: "blob",
        },
      );

      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "comprovantes.zip");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return new HttpResponse(false, status, data);
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    }
  };

  const listarReprovados = useCallback(
    async (dadosFiltros?: IFiltrosAprovadoPagamento, status = "REPROVADO") => {
      setLoading(true);
      setClearRows(true);
      const obj: any = { pagina: page, limite: limit, status };

      if (dadosFiltros) {
        setFiltroListaReprovados(dadosFiltros);
      }

      const params = getParamsFiltroReprovados(
        obj,
        dadosFiltros ?? filtroListaReprovados,
      );

      try {
        const { status, data } = await msAw.get(
          `/fornecedores/pagamento/lote/?${params}`,
        );

        setDadosReprovados(data.itens);
        setTotalRows(data.meta.total);
        const response = new HttpResponse(false, status, data);
        setError(response);
        return response;
      } catch (error: IHttpError<IData, any> | any) {
        const response = new HttpError<IData>(true, error);
        setError(response);
        setDadosReprovados([]);
        setTotalRows(0);
        return response;
      } finally {
        setLoading(false);
        setClearRows(false);
      }
    },
    [page, limit, filtroListaReprovados],
  );

  const buscarReciboNf = async (idLote: number, numeroNfRecibo: string) => {
    try {
      const { status, data, headers } = await msAw.get(
        `/fornecedores/pagamento/lote/${idLote}/imagem/recibo`,
        {
          responseType: "blob",
        },
      );

      const contentType = headers["content-type"] || "application/octet-stream";
      const extensao = mimeMap[contentType] || "bin";

      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `recibo_nf_${numeroNfRecibo}.${extensao}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return new HttpResponse(false, status, data);
    } catch (error: IHttpError<IData, any> | any) {
      toastErro("Não foi possível baixar o arquivo");
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    }
  };

  const validarPlacasChassis = async (placasChassis: string[]) => {
    setLoading(true);
    try {
      const { status, data } = await msAw.get(
        `/processo/placa/chassi/validar/?placasChassis=${JSON.stringify(
          placasChassis,
        )}`,
      );

      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    } finally {
      setLoading(false);
    }
  };

  const enviarLotesParaCorrecao = async (motivoCorrigir: string) => {
    setLoading(true);
    try {
      const { status, data } = await msAw.patch(
        "/fornecedores/pagamento/lote/correcao",
        { observacao: motivoCorrigir, ids: selectedRows.map((row) => row.id) },
      );

      if (
        data &&
        Array.isArray(data) &&
        data.some((lote) => !lote.atualizado)
      ) {
        toastAtencao("Alguns lotes não foram atualizados");
      }

      const response = new HttpResponse(false, status, data);
      setError(response);
      listarAprovados();
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    } finally {
      setLoading(false);
    }
  };

  const getParamsFiltroListarProcessosVincularLote = (
    filtros: IFiltroProcessoCriarLote,
  ) => {
    const obj: any = {};
    if (filtros.servico && filtros.empresa) {
      obj.servico = filtros.servico;
    }

    if (filtros.empresa) {
      obj.empresa = filtros.empresa;
    }

    if (filtros.divisao) {
      obj.divisao = filtros.divisao;
    }

    if (filtros.processos && filtros.processos.length) {
      obj.processos = JSON.stringify(filtros.processos);
    }

    if (filtros.placasChassis && filtros.placasChassis.length) {
      obj.placasChassis = JSON.stringify(filtros.placasChassis);
    }

    if (filtros.centroCusto) {
      obj.centroCusto = filtros.centroCusto;
    }

    let params = Object.keys(obj)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`,
      )
      .join("&");

    if (
      params &&
      (!filtros.placasChassis || !filtros.placasChassis.length) &&
      (!filtros.processos || !filtros.processos.length)
    ) {
      params = `${params}&ultimosXDias=90`;
    }

    return params;
  };

  const listarProcessosVincularLote = async (
    dados: IFiltroProcessoCriarLote,
  ) => {
    const params = getParamsFiltroListarProcessosVincularLote(dados);

    if (!params) {
      toastAtencao("Selecione pelo menos um filtro");
      return;
    }

    setLoading(true);
    setClearRows(true);
    try {
      const { status, data } = await msAw.get(
        `/processo/vincular/lote?${params}`,
      );

      setProcessosVincularLote(data);
      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      setProcessosVincularLote([]);
      return response;
    } finally {
      setLoading(false);
      setClearRows(false);
    }
  };

  const validarDuplicidade = async (
    dadosLote: ICriarLote,
    processos: IProcessoCriarLote[],
  ) => {
    const lista_lancamentos: IListaLancamentos[] = [];
    setLoading(true);

    processos.map((processo) => {
      processo.custos.map((custo) => {
        lista_lancamentos.push({
          status: "ok",
          id_processo: processo.idProcesso,
          tipo_lancamento: dadosLote.tipoLancamento,
          tipo_custo: custo.idDescricao,
          valor: custo.valor,
          observacao: "",
          id_fornecedor: dadosLote.fornecedor,
          lancamento_duplicado: false,
        });
      });
    });

    try {
      const { status, data } = await api.post(
        `/processos/financeiro/lote/duplicidade`,
        { lista_lancamentos: JSON.stringify(lista_lancamentos) },
      );

      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    } finally {
      setLoading(false);
    }
  };

  const salvarLote = async (
    dadosLote: ICriarLote,
    listaLancamentos: IListaLancamentos[],
  ) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("arquivo", dadosLote.arquivo);
      formData.append("numero_nf_recibo", `${dadosLote.numeroNfRecibo}`);
      formData.append("valor", `${dadosLote.valorNfRecibo}`);
      formData.append("lista_lancamentos", JSON.stringify(listaLancamentos));

      const { status, data } = await api.post(
        `/processos/financeiro/lote/avaliacao`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    } finally {
      setLoading(false);
    }
  };

  const [optionsMotivoCorrigirLote, setOptionsMotivoCorrigirLote] = useState<
    IOptions[]
  >([]);

  const buscarOptionsMotivoCorrigirLote = async () => {
    try {
      const { status, data } = await msAw.get(`/pagamento/lote/motivo`);
      const response = new HttpResponse(false, status, data);
      setError(response);

      const options = data.map((motivo: { id: number; nome: string }) => {
        return { value: motivo.nome, label: motivo.nome };
      });
      setOptionsMotivoCorrigirLote([
        ...options,
        { value: "Outros", label: "Outros" },
      ]);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      setOptionsMotivoCorrigirLote([]);
      return response;
    }
  };

  const removerProcessosLote = useCallback(
    async (idLote: number) => {
      setLoading(true);

      try {
        const { status, data } = await msAw.patch(
          `/fornecedores/pagamento/lote/${idLote}/remover`,
          {
            idsProcessos: selectedRowsCorrigir.map(
              (processo) => processo.idProcessoFinanceiroAprovar,
            ),
          },
        );

        const response = new HttpResponse(false, status, data);
        setError(response);
        return response;
      } catch (error: IHttpError<IData, any> | any) {
        const response = new HttpError<IData>(true, error);
        setError(response);
        return response;
      } finally {
        setLoading(false);
      }
    },
    [page, limit, selectedRowsCorrigir],
  );

  const editarProcessoFinanceiroAprovar = async (dados: IEditarProcesso) => {
    try {
      const { status, data } = await msAw.patch(
        `/fornecedores/pagamento/${dados.idProcessoFinanceiroAprovar}/`,
        { valor: dados.valorDepois, idDescricao: dados.servicoDepois },
      );
      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    }
  };

  const atualizarLoteProcessoFinanceiroAprovar = async (
    dados: IAtualizarLote,
  ) => {
    try {
      const formData = new FormData();
      formData.append("arquivo", dados.arquivo);
      formData.append("valor_nf_recibo", `${dados.valorNfRecibo}`);
      formData.append("numero_nf_recibo", `${dados.numeroNfRecibo}`);

      const { status, data } = await api.post(
        `processos/financeiro/lote/${dados.idLote}/arquivo`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const response = new HttpResponse(false, status, data);
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      setError(response);
      return response;
    }
  };

  return {
    listar,
    error,
    totalRows,
    page,
    limit,
    loading,
    dados,
    setDados,
    setPage,
    setLimit,
    filtro,
    setFiltro,
    selectedRows,
    setSelectedRows,
    aprovarLotes,
    reprovarLotes,
    idLoteEscolhido,
    setIdLoteEscolhido,
    dadosDetalhes,
    setDadosDetalhes,
    buscarDetalhesLotePagamento,
    buscarEstatisticasLotePagamento,
    buscarEstatisticasPagamento,
    onClickProcesso,
    relatorioDetalhado,
    relatorioResumido,
    validarProcessos,
    listarAprovados,
    setFiltroListaAprovados,
    filtroListaAprovados,
    dadosAprovados,
    confirmarPagamento,
    buscarComprovantes,
    numeroNfReciboEscolhido,
    listarReprovados,
    dadosReprovados,
    buscarReciboNf,
    validarLotes,
    clearRows,
    validarPlacasChassis,
    listarProcessosVincularLote,
    processosVincularLote,
    setProcessosVincularLote,
    salvarLote,
    enviarLotesParaCorrecao,
    buscarOptionsMotivoCorrigirLote,
    optionsMotivoCorrigirLote,
    idLoteCorrigir,
    setIdLoteCorrigir,
    selectedRowsCorrigir,
    setSelectedRowsCorrigir,
    removerProcessosLote,
    editarProcessoFinanceiroAprovar,
    atualizarLoteProcessoFinanceiroAprovar,
    validarDuplicidade,
    filtroListaReprovados,
  };
}
